(ns app.domain.workspace.closure-category-model
  (:require [app.domain.group.permit-type-config.model :as ptc-model]
            [app.domain.phase-result.model :as phase-result-model]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.user.model :as user-model]))

(defn status-text [status enabled? language {:keys           [closure-category-names]
                                             :workspace/keys [permit-type]}]
  (let [category (when (and enabled? (ptc-model/permit-types-with-closure-categories permit-type))
                   (i18n-model/get-text-from-entities-or-map closure-category-names language))]
    (if (str/blank? category)
      status
      (str (some-> status str/trimr) "; " category))))

(defn transition-metadata
  "Read the current terminal transition's actor and timestamp from the phase."
  [phase]
  (let [cancelled? (= :execution.state/cancelled-work-order (:domain/state phase))
        timestamp  (if cancelled?
                     (:execution/cancelled-ts phase)
                     (:execution/closed-ts phase))
        actor      (if cancelled?
                     (:execution/cancelled-by phase)
                     (:execution/closed-by phase))]
    {:actor     (when timestamp
                  (some-> actor user-model/full-name))
     :timestamp timestamp}))

(defn summary-data
  "Build the saved outcome summary from readable phase and Result entities."
  [enabled? language {:workspace/keys [permit-type]} {:domain/keys [state] :as phase}]
  (when (and enabled? (ptc-model/permit-types-with-closure-categories permit-type))
    (let [result   (phase-result-model/get-published-result phase)
          category (some-> result :phase-result/closure-category :closure-category/names
                           (i18n-model/get-text-from-entities-or-map language))]
      (when-not (str/blank? category)
        (merge {:state       state
                :category    category
                :description (:phase-result/description result)}
               (transition-metadata phase))))))
